import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_COMPANIES } from '@/api/queries';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { CompanyInput, CompanyOutput, CompanyQuery } from '@/api/gql/graphql';
import { CREATE_COMPANY } from '@/api/mutations/company';

export const useGetCompanies = (query: CompanyQuery) => {
  const queryClient = useQueryClient();
  return useQuery<CompanyOutput[], Error>({
    queryKey: ['companies', query],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getCompanies: CompanyOutput[] },
        { query: CompanyQuery }
      >(GET_COMPANIES, { query });
      return data.getCompanies;
    },
  });
};

export const useAddCompany = () => {
  const queryClient = useQueryClient()
  return useMutation<CompanyOutput, Error, CompanyInput>({
    mutationFn: async (input: CompanyInput) => {
      const data = await graphqlFetch<
        { createCompany: CompanyOutput },
        { input: CompanyInput }
      >(CREATE_COMPANY, { input });
      return data.createCompany;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companies"] })
    }
  });
};
